module.exports = {"id":"198394","name":"Alexander Kačaniklić","rating":"71","photo":"./data/images/photos/1/198394.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexanderKacaniklic0.json
// module id = 233
// module chunks = 0